import React from 'react';

const CONTACT = 'lukykyh.v1@gmail.com';

// Page legale : confidentialite + conditions d'utilisation + contact.
// TerraGuessr traite des messages Discord (donnees personnelles) -> transparence.
export function LegalPage({ tab = 'privacy', onBack }) {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <button type="button" className="btn legal-back" onClick={onBack}>← Retour</button>

        {tab !== 'terms' && (
          <section id="privacy">
            <h1>Politique de confidentialite</h1>
            <p><em>Derniere mise a jour : 2026.</em></p>

            <h2>Qui sommes-nous</h2>
            <p>TerraGuessr est un jeu prive entre amis. Responsable du traitement : Aniss. Contact : <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.</p>

            <h2>Donnees traitees</h2>
            <ul>
              <li><strong>Identite de jeu</strong> : le pseudo que tu choisis (stocke dans ton navigateur, localStorage).</li>
              <li><strong>Compte Discord (optionnel)</strong> : si tu te connectes via Discord, on lit ton identifiant, ton nom et ton avatar (scope <code>identify</code>) pour afficher ton profil et ton classement ELO.</li>
              <li><strong>Messages importes</strong> : pour jouer, l'hote d'un salon importe un export de messages Discord (auteurs, contenus, dates). Ces donnees servent uniquement a generer les manches.</li>
              <li><strong>Statistiques de jeu</strong> : parties, victoires, score ELO (associes a ton identifiant Discord).</li>
            </ul>

            <h2>Duree de conservation</h2>
            <p>Les messages importes pour un salon sont <strong>volatils</strong> : gardes en memoire vive le temps de la partie, supprimes a la fermeture du salon (rien n'est ecrit en base pour ces contenus). Seuls le profil (pseudo/avatar Discord) et les statistiques ELO sont conserves de facon persistante, tant que tu utilises le service.</p>

            <h2>Cookies</h2>
            <p>On utilise uniquement des cookies/stockage <strong>strictement necessaires</strong> (session, jeton d'authentification, pseudo). Pas de cookie publicitaire. Si une mesure d'audience anonyme est activee, elle est signalee dans le bandeau.</p>

            <h2>Partage</h2>
            <p>Aucune donnee n'est vendue. Les seuls tiers impliques sont Discord (authentification) et l'hebergeur du service. Le mode musique interroge notre service Terrashup (bibliotheque de mashups).</p>

            <h2>Tes droits</h2>
            <p>Acces, rectification, suppression de tes donnees (profil/ELO) : ecris a <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.</p>
          </section>
        )}

        {tab === 'terms' && (
          <section id="terms">
            <h1>Conditions d'utilisation</h1>
            <p><em>Derniere mise a jour : 2026.</em></p>
            <h2>Objet</h2>
            <p>TerraGuessr est un jeu prive fourni gratuitement, sans garantie, pour un usage entre amis.</p>
            <h2>Usage acceptable</h2>
            <ul>
              <li>N'importe que des messages dont tu as le droit de disposer (ton propre serveur/groupe).</li>
              <li>Pas d'usage abusif, de harcelement, ni de contenu illegal.</li>
              <li>Le service peut etre indisponible ou modifie a tout moment.</li>
            </ul>
            <h2>Responsabilite</h2>
            <p>Le service est fourni "en l'etat". L'auteur ne saurait etre tenu responsable des donnees importees par les utilisateurs ni des interruptions de service.</p>
            <h2>Contact</h2>
            <p><a href={`mailto:${CONTACT}`}>{CONTACT}</a></p>
          </section>
        )}

        <div className="legal-links">
          <a href="#/privacy">Confidentialite</a> · <a href="#/terms">Conditions</a> · <a href={`mailto:${CONTACT}`}>Contact</a>
        </div>
      </div>
    </div>
  );
}
